import { memo } from 'react';

import { SectionContainer } from '../../../components/SectionContainer/SectionContainer';
import { StyledTable } from './DearLineTable.styles';
import { DearLineTableProps } from './DearLineTable.types';

function DearLineTable<T>(props: DearLineTableProps<T>) {
    const { title, columnDefinitions, lineItems } = props;

    return (
        <SectionContainer title={title}>
            <StyledTable columnDefinitions={columnDefinitions} lineItems={lineItems} />
        </SectionContainer>
    );
}

export default memo(DearLineTable);
